import { useCallback, useState } from 'react';

import { resetSessionCaches } from '@/core/hooks/reset-session-caches';
import { revokePushTokenOnLogout } from '@/core/lib/push-notifications';
import { useAuthStore } from '@/core/store/auth.store';

/**
 * Performs a full logout: clears auth and all user/session caches.
 * Can be called outside of React components.
 */
export async function performFullLogout() {
  await revokePushTokenOnLogout();
  useAuthStore.getState().logout();
  resetSessionCaches();
}

export function useLogout() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const requestLogout = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const confirmLogout = useCallback(() => {
    setDialogOpen(false);
    void performFullLogout();
  }, []);

  return { dialogOpen, setDialogOpen, requestLogout, confirmLogout };
}
